import React from 'react';

interface Props {
  children: React.ReactNode;
}

const ButtonGroup = (props: Props) => {
  return (
    <div className="row align-items-center justify-content-center">
      {props.children}
    </div>
  )
}

export default ButtonGroup
